import { Component } from '@angular/core';
import { RegisterComponent } from '@curbnturf/auth-components/src/lib/register/register.component';
import { IonContent } from '@ionic/angular/standalone';

@Component({
  selector: 'curbnturf-register-modal',
  templateUrl: './register-modal.component.html',
  styleUrls: ['./register-modal.component.scss'],
  standalone: true,
  imports: [IonContent, RegisterComponent],
})
export class RegisterModalComponent {}
